import { Chip } from "@mui/material";
import { Person } from "@mui/icons-material";

function LoadingChip() {
  return <Chip label="Loading" icon={<Person />} size="small" />;
}

export default LoadingChip;
